import React, { useState, useEffect} from 'react';
import * as Calc from './libraries/Calc.js';
//import Disclaimer from './Disclaimer';

function CalChurnRetention(props) {
  

  const [users,setUsers] = useState(5000);
  const [lifetimeValue,setLifetimeValue] = useState(100);
  
  //const [averageRevenuePerUser,setAverageRevenuePerUser] = useState(100);
  //const [acquisitionCostPerUser,setAcquisitionCostPerUser] = useState(1000);
  //const [rate,setRate] = useState(10);
  
  //const [result,setResult] = useState(0);

  const [resultEstimatedAnnualRevenueLost,setResultEstimatedAnnualRevenueLost] = useState(0);
  
  
  useEffect(()=>{
    //setResultEstimatedAnnualRevenueLost(users*(lifetimeValue/2));
    setResultEstimatedAnnualRevenueLost(users*(lifetimeValue));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[users,lifetimeValue]);
  

  return (
    <div className="row d-flex justify-content-center CalChurnRetention">
      <div className="col-12 col-lg-6 pe-lg-0">
        <div className="card card_calc">
          <div className="card-body position-relative mt-2">
            <form>
              {/*
              <div className="mb-3">
                <label htmlFor="CalChurnRetention_range_revenue" className="form-label">Roughly, What is your annual recurring revenue?</label>
                <input type="range" className="form-range" id="CalChurnRetention_range_revenue" aria-describedby="revenue" placeholder="Revenue" min={props.revenue??10000} step="10000" value={revenue} max="5000000" onChange={(e)=>setRevenue(e.target.value)}/>
                <small>{Calc.formatCurrency(revenue)}</small>
              </div>
              */}

              <div className="mt-0 my-lg-5">
                <label htmlFor="CalChurnRetention_range_users" className="form-label d-flex align-items-center justify-content-between">
                  <div>
                    <h2 className="fw-bolder">Annual Churn:</h2>
                    <div className="h5 mb-0 d-none"><small>Number of users that churn each month</small></div>
                  </div>
                  <div>
                    {/*
                    {Calc.formatNumber(users)}
                    */}
                    <input type="text" className="form-control text-end" placeholder="Monthly Churn" value={users}  onChange={(e)=>setUsers(e.target.value)} style={{ width: '120px' }}/>
                  </div>
                </label>
                <input type="range" className="form-range" id="CalChurnRetention_range_users" aria-describedby="users" placeholder="users" min={100} max="2000000" step="100" value={users} onChange={(e)=>setUsers(e.target.value)}/>
              </div>

              <div className="my-5 position-relative">
                <label htmlFor="CalChurnRetention_range_lifetimeValue" className="form-label d-flex align-items-center justify-content-between">
                  <div>
                    <h2 className="fw-bolder">Customer LTV:</h2>
                    <div className="h5 mb-0 d-none"><small>Average lifetime value per customer</small></div>
                  </div>
                  <div>
                    {/*
                    {Calc.formatCurrency(lifetimeValue)}
                    */}
                    <div className="input-group mb-0" style={{ width: '150px' }}>
                      <span className="input-group-text">$</span>
                      <input type="text" className="form-control text-end" placeholder="Lifetime Value" value={lifetimeValue} onChange={(e)=>setLifetimeValue(e.target.value)}/>
                    </div>
                  </div>
                </label>
                <input type="range" className="form-range" id="CalChurnRetention_range_lifetimeValue" placeholder="Lifetime Value" min="10" max="10000" step="100" value={lifetimeValue} onChange={(e)=>setLifetimeValue(e.target.value)}/>
              </div>

              {/*
              <div className="mb-3 position-relative">
                <label htmlFor="CalChurnRetention_range_averageRevenuePerUser" className="form-label d-flex align-items-center justify-content-between">
                  <div>
                    <h2 className="fw-bolder">Revenue / Customer:</h2>
                    <div className="h5 mb-0"><small>Average revenue per customer</small></div>
                  </div>
                  <div>
                    <div class="input-group mb-3" style={{ width: '150px' }}>
                      <span class="input-group-text">$</span>
                      <input type="text" className="form-control text-end" placeholder="Average Revenue Per User" value={averageRevenuePerUser} onChange={(e)=>setAverageRevenuePerUser(e.target.value)}/>
                    </div>
                  </div>
                </label>
                <input type="range" className="form-range" id="CalChurnRetention_range_averageRevenuePerUser" placeholder="Average Revenue Per User" min="10" max="10000" step="100" value={averageRevenuePerUser} onChange={(e)=>setAverageRevenuePerUser(e.target.value)}/>
              </div>
              */}

 
              <div className="bottom_result">
                <div>
                  <h6 className="fw-bolder mb-0" style={{ fontSize: '25px', color: '#535252' }}>Lifetime <br/>Loss of Revenue:</h6>
                  <h5 className="fw-bolder mb-0" style={{ fontSize: '80px', color: '#535252', fontWeight: '900' }}>${Calc.formatCurrency3(resultEstimatedAnnualRevenueLost)}</h5>
                </div>
              </div>
              
            </form>
          </div>
        </div>
      </div>

      <div className="col-12 col-lg-6 ps-lg-0">
        <div className="card card_result">
          <div className="card-body position-relative mt-2">
            <div>
              <div className="card-title h2 fw-bolder" style={{ fontSize: '40px', color: '#fff' }}>
                LiveX AI Churn Reduction
              </div>
              
              <div className="my-4">
                <h3 style={{ fontSize: '30px',color: '#fff' }} className="mb-0">Annual Churn: {Calc.formatNumber(users)}</h3>
                <small style={{ fontSize: '20px', color: '#fff' }}>Current annual number of users that churn</small>  
              </div>

              <div className="my-4">
                <div style={{ fontSize: '30px',color: '#fff' }} className="h3 mb-0">Churn Reduction: <h3 className="d-inline fw-bolder" style={{ fontSize: '40px', color: '#fff' }}>30%</h3></div>
                <small style={{ fontSize: '20px', color: '#fff' }}>LiveX AI ChurnControl average deflection rate</small>  
              </div>
              
              <div className="bottom_result">
                <div>
                  <h2 className="mb-0 fw-bolder" style={{ fontSize: '25px', color: '#ffb350' }}>Lifetime <br/>Revenue Recovered:</h2>
                  <h2 className="mb-0" style={{ fontSize: '80px', color: '#ffb350', fontWeight: '900' }}>${Calc.formatCurrency3(resultEstimatedAnnualRevenueLost*0.3)}</h2>
                </div>
              </div>

              {/*
              <div className="row">
                <div className="col-12">
                  <button className="btn btn-sm btn-email">Email Result</button>
                </div>
              </div>
              */}

              {/*
              <div className="bottom_result">
                <div className="col-12 d-lg-flex justify-content-lg-between align-items-center">
                  <div>
                    <h6 className="fw-bolder mb-lg-0 lh-base">New Lifetime Loss of Revenue as Low as: {Calc.formatCurrency(resultEstimatedAnnualRevenueLost*0.7)}</h6>
                  </div>
                  <div>
                    <button className="btn btn-sm btn-email d-none">Email Result</button>
                  </div>
                </div>
              </div>
              */}

              {/*<Disclaimer/>*/}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CalChurnRetention;
